import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { HelperService } from '../../../services';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.css']
})
export class VideoModalComponent implements OnInit {

  public playerID;

  @Input() videoURL: string;
  @Input() videoType: string;
  @Input() videoTitle: string;
  @Input() isS3VideoFileURL: boolean;

  @ViewChild('videoPlayer') videoplayer: ElementRef;

  constructor(
    private helperService: HelperService
  ) { }

  ngOnInit() {
    this.playerID = localStorage.getItem('playerID');
  }

  getEmbedUrl(url) {
    return this.helperService.getVideoEmbedUrl(url);
  }

  toggleVideo(event: any) {
    this.videoplayer.nativeElement.play();

    //fetch(this.videoURL)
    //  .then(response => response.blob())
    //  .then(blob => {
    //    this.videoplayer.nativeElement.srcObject = blob;
    //    return this.videoplayer.nativeElement.play();
    //  })
    //  .then(_ => {
    //    // Video playback started ;)
    //    console.log('Video playback started');
    //  })
    //  .catch(e => {
    //    // Video playback failed ;(
    //    console.log('Video playback failed');
    //  })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/video-modal/video-modal.component.ts